module.exports = __webpack_public_path__ + "abbd7decd9ff40eb6f017057d94315d9.png";